/**
 * Settings → Backup & Transfer (F01-P4/P4b/P6).
 *
 * Move your preferences to another machine, or keep a copy before a reinstall.
 *
 * Saved connections are a SEPARATE file with its own rules, not a group inside
 * the settings bundle: `connections.json` is on the settings deny-list and the
 * settings guard throws if it appears. The connections file is assembled in the
 * main process (only main can decrypt a stored password) and its secrets half
 * is passphrase-encrypted or absent — never plaintext.
 */
import { Separator } from '../../../components/ui/separator';
import { ConnectionsExportPanel } from '../../connections/connection-transfer/ConnectionsExportPanel';
import { ConnectionsImportPanel } from '../../connections/connection-transfer/ConnectionsImportPanel';
import { SettingsExportPanel } from './SettingsExportPanel';
import { SettingsImportPanel } from './SettingsImportPanel';

export function BackupTransferSettingsTab() {
  return (
    <div className="space-y-5" data-testid="backup-transfer-settings-tab">
      <p className="text-xs text-muted-foreground">
        Move your preferences and saved connections between machines. Both are plain JSON you can
        read before you share them — except a connections file's saved passwords, which are only
        ever written encrypted under a passphrase you choose.
      </p>

      <SettingsExportPanel />
      <Separator />
      <SettingsImportPanel />

      <Separator />
      <div className="text-sm font-semibold">Saved connections</div>
      <p className="text-xs text-muted-foreground">
        Cloning a whole setup? Import connections <em>before</em> importing database meta info —
        meta-info records re-attach by connection id.
      </p>
      <ConnectionsExportPanel />
      <Separator />
      <ConnectionsImportPanel />
    </div>
  );
}
